import { internalUrls } from './config.internalUrls';

const domain = document.domain;

const tprecmApiUrls = internalUrls.includes(domain) ?
   {

      'LOCAL': 'http://localhost.gm.com:8081/',
      'DEV': 'https://mesc-service-dev.musea2.azure.ext.gm.com/tprecm-service/',
      'QA': 'https://tprecm-service-api-ocf-qa.apps.pcfepgstg1mi.gm.com/',
      'TEST': 'https://tprecm-service-api-ocf-test.apps.pcfepgstg1mi.gm.com/',
      'PROD': 'https://tprecm-api.oc1i.gm.com/',

   } :
   {
      'DEV': 'https://mesc-service-dev.musea2.azure.ext.gm.com/tprecm-service/',
      'TEST': 'https://mfg-gateway.tst.gm.com/tprecm/api/',
      'QA': 'https://mfg-gateway-qa.gm.com/tprecm/api/',
      'PROD': 'https://mfg-gateway.gm.com/tprecm/api/'
   };

/**
 *
 */
export const mescUrl = {

   'LOCAL': 'http://localhost.gm.com/',
   'DEV': 'https://mesc-dev.musea2.azure.ext.gm.com/',
   'QA': 'https://mesc-ui-ocf-qa.apps.pcfepgstg1mi.gm.com/',
   'TEST': 'https://mesc-ui-ocf-test.apps.pcfepgstg1mi.gm.com/',
   'PROD': 'https://mesc.musea2.azure.ext.gm.com/',

};

export const tprecmConfig = {
   tprecmApiBaseUrl: tprecmApiUrls,
};



